'use client';

export default function PricingSection() {
  const services = [
    { name: 'General Notarization', note: 'Per signature, per document' },
    { name: 'Power of Attorney', note: 'Standard & durable' },
    { name: 'Loan Signing — Refinance', note: 'Full package' },
    { name: 'Loan Signing — Purchase', note: 'Full package' },
    { name: 'Real Estate Documents', note: 'Deeds, transfers, closings' },
    { name: 'I-9 Verification', note: 'Per employee' },
    { name: 'Hospital / Jail Signing', note: 'Includes travel' },
    { name: 'After-Hours / Weekend', note: 'Additional fee may apply' },
  ];

  return (
    <section id="pricing" className="bg-navy py-24 md:py-36">
      <div className="max-w-editorial mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-start">
          {/* Left: heading */}
          <div>
            <p className="section-label mb-4">Pricing</p>
            <div className="editorial-divider" />
            <h2 className="section-heading mb-6">
              Transparent pricing,<br />
              <span className="text-gold italic">no surprises.</span>
            </h2>
            <p className="font-dm text-[0.9rem] text-slate leading-relaxed mb-8">
              Every signing is different. Pricing depends on document type, location, and time of day.
              We provide exact quotes upfront — no hidden fees, ever.
            </p>

            {/* Pricing highlights */}
            <div className="space-y-4 mb-10">
              {[
                { label: 'Free quote', desc: 'Get an exact price before you commit' },
                { label: 'No hidden fees', desc: 'Travel, printing, and time all included in your quote' },
                { label: 'Competitive rates', desc: 'Fair pricing for the DFW market' },
              ]?.map((item) => (
                <div key={item?.label} className="flex items-start gap-4">
                  <div className="w-5 h-5 rounded-full border border-gold/40 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">
                      <path d="M2 5l2 2 4-4" stroke="#C9A84C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                  <div>
                    <span className="font-dm text-[0.85rem] font-700 text-cream">{item?.label}</span>
                    <span className="font-dm text-[0.85rem] text-slate"> — {item?.desc}</span>
                  </div>
                </div>
              ))}
            </div>

            <a href="#contact" className="cta-primary">
              Get a Free Quote
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </a>
          </div>

          {/* Right: service list */}
          <div>
            <p className="font-dm text-[0.65rem] font-700 uppercase tracking-[0.25em] text-slate mb-6">
              Services &amp; Pricing
            </p>
            <div className="divide-y divide-white/6">
              {services?.map((service) => (
                <div key={service?.name} className="flex items-center justify-between py-4 group">
                  <div>
                    <p className="font-dm text-[0.88rem] font-600 text-cream group-hover:text-gold transition-colors">
                      {service?.name}
                    </p>
                    <p className="font-dm text-[0.75rem] text-slate mt-0.5">{service?.note}</p>
                  </div>
                  <span className="font-fraunces text-[0.9rem] font-600 text-gold/80 flex-shrink-0 ml-4">
                    Contact for pricing
                  </span>
                </div>
              ))}
            </div>

            {/* Note */}
            <div className="mt-8 p-5 rounded-lg bg-gold-faint border border-gold/20">
              <p className="font-dm text-[0.8rem] text-cream leading-relaxed">
                <span className="font-700 text-gold">Texas state law</span> sets a maximum fee of $6 per notarial act.
                Our mobile service fee covers travel, time, and convenience — always quoted upfront.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}